module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 500 200",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }